import { render, staticRenderFns } from "./TheApplicationSidebarMenu.vue?vue&type=template&id=2dc52c72&"
import script from "./TheApplicationSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./TheApplicationSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports